import React, { useState, useEffect } from 'react';
import { apiFetch } from '../../App';
import { MapPin, Store, Truck, Box, Star, Phone, Clock, ExternalLink } from 'lucide-react';

const TYPE_ICONS = { STORE: Store, VAN: Truck, POD: Box };

export default function DenNodes() {
  const [nodes, setNodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiFetch('/api/nodes?active_only=false').then(n => { setNodes(n); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="den-nodes">
      <h1 className="font-outfit text-2xl font-bold mb-6" style={{ color: 'var(--text-primary)' }}>Locations</h1>

      {loading ? (
        <div className="grid sm:grid-cols-2 gap-4">{[1,2,3,4].map(i => <div key={i} className="skeleton h-48 rounded-2xl" />)}</div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-6">
          {nodes.map(node => {
            const Icon = TYPE_ICONS[node.type] || Store;
            return (
              <div key={node.id} className="petfolk-card overflow-hidden" data-testid={`den-node-${node.slug}`}>
                <div className="relative h-36">
                  <img src={node.heroImageUrl || node.storeImageUrl} alt={node.displayName} className="w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                  <div className="absolute top-3 right-3 flex gap-2">
                    <span className="glass rounded-lg px-2 py-1 text-xs font-semibold text-white">{node.type}</span>
                    {node.isFranchise && <span className="bg-petfolk-purple/80 rounded-lg px-2 py-1 text-xs font-semibold text-white">Franchise</span>}
                    {node.comingSoon && <span className="bg-yellow-500/80 rounded-lg px-2 py-1 text-xs font-semibold text-white">Coming Soon</span>}
                  </div>
                  <div className="absolute bottom-3 left-4">
                    <h3 className="text-white font-outfit font-bold text-lg">{node.displayName}</h3>
                    <p className="text-white/70 text-xs">{node.localName} - {node.cityName}</p>
                  </div>
                </div>
                <div className="p-4 space-y-2">
                  <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--text-secondary)' }}>
                    <MapPin size={12} /> {node.address || 'No address set'}
                  </div>
                  {node.phone && (
                    <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--text-secondary)' }}>
                      <Phone size={12} /> {node.phone}
                    </div>
                  )}
                  {node.operatingHours && (
                    <div className="flex items-center gap-2 text-xs" style={{ color: 'var(--text-secondary)' }}>
                      <Clock size={12} /> {node.operatingHours.open} - {node.operatingHours.close}
                    </div>
                  )}
                  <div className="flex items-center justify-between pt-2" style={{ borderTop: '1px solid var(--border-color)' }}>
                    <div className="flex items-center gap-1">
                      <div className="w-4 h-4 rounded" style={{ background: node.themePrimaryColor || '#FF8C42' }} />
                      <div className="w-4 h-4 rounded" style={{ background: node.themeSecondaryColor || '#8B5CF6' }} />
                    </div>
                    {node.isFranchise && (
                      <span className="text-xs" style={{ color: 'var(--text-secondary)' }}>Rev share: {(node.franchiseRevShare * 100).toFixed(0)}%</span>
                    )}
                    <a href={`/${node.slug}`} target="_blank" rel="noreferrer" className="text-xs font-semibold text-petfolk-orange flex items-center gap-1">
                      View <ExternalLink size={10} />
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
